import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Form from '../../modules/Form'
import { Container, Row, Col, FormGroup, Label, Input, Button, Alert, Card, CardFooter, CardBody, CardTitle } from 'reactstrap'
import {
  loadAppeal, createReply
} from '../../actions/appealActions'
import { withRouter } from 'react-router'
import Loading from '../loading'
import PropTypes from 'prop-types'
import { FaCommentAlt, FaCreditCard } from 'react-icons/fa'
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import FileUploadChat from '../shared/_FileUploadChat'

// import { push } from 'connected-react-router'
var moment = require('moment')

class AppealMessages extends Component {
  constructor (props) {
    super(props)
    this.pdfArea = React.createRef(this.pdfArea)
    this.state = {
      pdfWidth: 0
    }
    this.setPDFSize = this.setPDFSize.bind(this)
    this.lastRef = React.createRef(this.lastRef)
  }

  componentDidMount () {
    this.props.loadAppeal(this.props.match.params.appealID)
    // if already loaded then resize pdf
    if (this.props.appeal.data.appealID) {
      this.setPDFSize()
      window.addEventListener('resize', this.setPDFSize)
    }
    setTimeout(() => this.lastRef.current && this.lastRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' }), 1000)
  }

  componentDidUpdate (prev) {
    if (this.props.appeal.data.appealID && !prev.appeal.data.appealID) {
      this.setPDFSize()
      window.addEventListener('resize', this.setPDFSize)
    }

    if (this.props.appeal.data.replies && prev.appeal.data.replies && this.props.appeal.data.replies !== prev.appeal.data.replies) {
      console.log('fired')
      setTimeout(() => this.lastRef.current && this.lastRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100)
    }
  }

  setPDFSize () {
    this.setState({ pdfWidth: (this.pdfArea.current.getBoundingClientRect().width - 40) })
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.setPDFSize)
  }

  render () {
    let theChild
    this.props.replies.sort(function (a, b) {
      const aa = JSON.parse(a)
      const bb = JSON.parse(b)
      return new Date(aa.timestamp) - new Date(bb.timestamp)
    })

    const adminReplies = this.props.replies.filter(reply => JSON.parse(reply).user === 'adjudicator')
    const lastAdminReply = adminReplies.length ? JSON.parse(adminReplies[adminReplies.length - 1]) : null
    if (this.props.appeal.data.appealID) {
      theChild =
        <Container>
          <Row>
            <Col sm='12' md={{ size: 10, offset: 1 }} >
              <div className='chat-area mb-5'>
                <div className='chat chat--them mb-5'>
                  <div ref={this.pdfArea} className='chat__content'>
                    <p>{this.props.appeal.data.detail}</p>
                  </div>
                  <div className='chat__date'>Appeal detail - {moment(this.props.appeal.data.date).format('DD/MM/YY')}</div>
                </div>
                {
                  this.props.replies.map((reply, i) => {
                    const msg = JSON.parse(reply)
                    return (
                      <div key={i} ref={((i !== 0 && i === (this.props.replies.length - 1))) ? this.lastRef : null} className={`chat mb-5 mt-5 ${msg.user === 'adjudicator' ? 'chat--them' : 'chat--us'}`}>
                        <div className='chat__content'>
                          <div dangerouslySetInnerHTML={{ __html: msg.reply }} />
                          { msg.pdfURL && msg.pdfURL.length &&
                          <div>
                            <br />
                            <a target='_blank' href={msg.pdfURL}>
                              <Document file={msg.pdfURL}>
                                <Page width={this.state.pdfWidth} pageNumber={1} />
                              </Document>
                            </a>
                          </div>
                          }
                        </div>
                        <div className='chat__date'>{msg.user === 'adjudicator' ? 'Admin' : msg.appellant} - {moment(msg.timestamp).format('HH:mm:ss DD/MM/YY')}</div>
                      </div>)
                  })}
                {lastAdminReply.showPaymentDetails === '1' &&
                <div>
                  <Card>
                    <CardTitle>
                      <FaCreditCard /> Make online payment
                    </CardTitle>
                    <CardBody>
                      <p>Click the button below to securely make a card payment through our payment gateway.</p>
                      <form name='epdq' action='https://payments.securetrading.net/process/payments/choice' method='POST'>
                        <input type='hidden' name='sitereference' value='rmsparkshield48910' />
                        <input type='hidden' name='currencyiso3a' value='GBP' />
                        <input type='hidden' name='mainamount' value={lastAdminReply.paymentAmount} />
                        <input type='hidden' name='version' value='1' />
                        <input type='hidden' name='orderreference' value={this.props.appeal.data.pcn} />
                        {/* <input type='hidden' name='returnurl' value={`https://parkshieldadmin.co.uk/appeal/${this.props.appeal.data.appealID}`} /> */}
                        <input type='hidden' name='supportedcardtypes' value='127' />
                        <input type='hidden' name='merchantdisplayname' value='Parking Enforcement' />
                        <Button color='primary'>Pay &pound;{lastAdminReply.paymentAmount}</Button>
                      </form>
                    </CardBody>
                  </Card>
                </div>
                }
                {this.props.appeal.data.status !== 'accepted' && this.props.appeal.data.status !== 'rejected' &&
                <div>
                  <Form id='reply' submit={this.props.createReply}>

                    <Card>
                      <CardBody>
                        <FormGroup>
                          <Label for='reply'>Add a reply</Label>
                          <Input type='textarea' name='reply' id={'reply'} required />
                          <div className='invalid-feedback' />
                        </FormGroup>
                        <Input type='hidden' name='appealID' id='appealID' value={this.props.appeal.data.appealID} />

                      </CardBody>
                      <CardFooter>
                        <Button color='primary' form='reply' disabled={this.props.appeal.submitting}><FaCommentAlt /> Add reply <span className='spinning' /></Button>
                      </CardFooter>
                    </Card>
                  </Form>
                  <p className='ml-2 mb-4'>Or</p>
                  <FileUploadChat />
                </div>
                }
                {(this.props.appeal.data.status === 'accepted' || this.props.appeal.data.status === 'rejected') &&
                  <Alert color='danger'>As your appeal has been {this.props.appeal.data.status}, you can no longer add replies.</Alert>
                }
              </div>
            </Col>
          </Row>
        </Container>
    } else {
      theChild = <Loading />
    }

    return (
      <div>
        {theChild}
      </div>
    )
  }
};

AppealMessages.propTypes = {
  loadAppeal: PropTypes.func,
  createReply: PropTypes.func,
  appeal: PropTypes.object,
  match: PropTypes.object,
  replies: PropTypes.array
}

const mapStateToProps = ({ appeal }) => ({
  appeal,
  replies: appeal.data.replies ? Array.from(appeal.data.replies.values) : []
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadAppeal,
      createReply
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AppealMessages))



// WEBPACK FOOTER //
// ./src/containers/appeal/AppealMessages.jsx